<template>
  <section class="content">
    <admin-header
      :title="'Data Options'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  import AdminHeader from '../AdminHeader'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminDataOption',
    data () {
      return {
        newEntityScreen: 'Admin - Data Options',
        searchEntityScreen: 'Admin - Data Option search',
        filterEventName: 'admin-data-option-filter',
        filterName: 'DataOptionFilter',
        entityName: 'data-option'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminDataOption.vue?0c9467ce